import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const NavContainer = styled.div`
  box-sizing: unset;
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  height: 50px;
  filter: drop-shadow(0 0 5px rgba(31, 31, 31, 0.1));
  position: fixed;
  bottom: 0;
`

export const NavSlot = styled.div<{
  navStart: boolean
  navEnd: boolean
}>`
  flex-basis: 15%;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-top-left-radius: ${({ navStart }) => (navStart ? '15px' : null)};
  border-top-right-radius: ${({ navEnd }) => (navEnd ? '15px' : null)};
`

export const NavSlotCurve = styled(NavSlot)`
  flex-basis: auto !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff'%3E%3Cpath d='M99,0A36.33,36.33,0,0,0,70,15,25,25,0,0,1,30,15,36.33,36.33,0,0,0,1,0H0V50H100V0Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: center;
  width: 100px;
`

export const NavLink = styled(Link)<{
  color: string
}>`
  width: 25px;
  height: 25px;
  line-height: 1.5;
  align-items: center;
  color: ${({ color }) => (color ? color : 'rgba(23, 29, 34, 0.87)')};
  border-radius: 50rem;
  padding: 0.5rem 0.5rem;
  transition: 0.3s all;
  box-sizing: unset;
  &:hover {
    transition: 0.3s all;
    background: rgba(0, 0, 0, 0.11);
    color: #005cdb;
  }
`

export const FloatingButton = styled(Link)`
  position: fixed;
  width: 50px;
  height: 50px;
  line-height: 3;
  text-align: center;
  border-radius: 50%;
  bottom: 35px;
  box-shadow: 0 10px 6px -6px #777;
  z-index: 1;
  transition: 0.3s all;
  background: #005cdb;
  color: #ffffff;
  &:hover {
    bottom: 40px;
    transition: 0.3s all;
  }
`
